import { useEffect, useState } from "react";

function DashboardPage() {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("loggedInUser");

if (storedUser) {
  setUser(JSON.parse(storedUser));
} else {
  // fallback (based on your current storage)
  const username = localStorage.getItem("user_name");
  const role = localStorage.getItem("role");

  if (username && role) {
    setUser({
      username: username,
      role: role
    });
  }
}
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(90deg, #16295c 0%, #1f3f7a 55%, #239b95 100%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "30px"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "700px",
          backgroundColor: "rgba(255,255,255,0.12)",
          border: "1px solid rgba(255,255,255,0.2)",
          borderRadius: "20px",
          padding: "40px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          textAlign: "center",
          color: "white"
        }}
      >
        <h1 style={{ marginBottom: "16px" }}>ダッシュボード</h1>

        <p style={{ fontSize: "18px", marginBottom: "10px" }}>
          ログインに成功しました。
        </p>

        {user && (
          <>
            <p>ユーザー名: {user.username}</p>
            <p>役割: {user.role}</p>
          </>
        )}
      </div>
    </div>
  );
}

export default DashboardPage;